import newBaseApi from "./newBase.api";

export const userParameterService = {
  ...newBaseApi,
  resource: 'usuario-parametro',
  module: 'configuracoes',
  profile: 'aluno',

  
  async getUserParameter() {
    return await userParameterService.get<{
      id: string,
      usuarioId: string,
      volume?: number,
      autoPlay?: boolean,
      tema?: 'Claro' | 'Escuro',
      idioma?: string,
      ultimaAtualizacao: string
    }>()
    .then(({ success, data }) => ({
      success,
      data: data !== null ? {
        id: data.id,
        userId: data.usuarioId,
        volume: data.volume,
        autoPlay: data.autoPlay,
        theme: data.tema ?? 'Escuro',
        language: data.idioma,
        lastUpdate: data.ultimaAtualizacao
      } : null 
    }))
    .catch((error) => {
      throw error
    })
  },

  async create(objData: {
    userId: string,
    volume?: number,
    autoPlay?: boolean,
    theme?: string,
    language?: string,
    lastUpdate?: string
  }) {

    const payload = {
      usuarioId: objData.userId,
      volume: objData.volume,
      autoPlay: objData.autoPlay,
      tema: objData.theme,
      idioma: objData.language,
      ultimaAtualizacao: objData.lastUpdate
    }

    return await userParameterService.post(null, payload)
  },

  async update(objData: {
    id: string,
    userId: string,
    volume?: number,
    autoPlay?: boolean,
    theme?: string,
    language?: string,
    lastUpdate?: string
  }) {

    const payload = {
      id: objData.id,
      usuarioId: objData.userId,
      volume: objData.volume,
      autoPlay: objData.autoPlay,
      tema: objData.theme,
      idioma: objData.language,
      ultimaAtualizacao: objData.lastUpdate
    }

    return await userParameterService.put(objData.id, payload)
  }
}